import Bro from 'brototype';

export function getp(obj, path, defaultValue) {
  return Bro(obj).iCanHaz(path) || defaultValue;
}

export function getmp(obj, path, defaultValue) {
  return Bro(obj).iCanHaz(path) || Bro(obj).iCanHaz('dataValues.' + path) || defaultValue;
}

export function setp(obj, path, val) {
  return Bro(obj).makeItHappen(path, val);
}



// WEBPACK FOOTER //
// ./src/helpers/getProp.js